module.exports = __webpack_public_path__ + "img/leftList0_active.c23e6e7a.svg";